<ng-template #headerAddAction>
  <button
    type="button"
    class="cabinet-client-page__add-button"
    (click)="onAdd()"
  >
    + {{ 'admin.users.add' | translate }}
  </button>
</ng-template>

<div class="admin-users core-screen">
  @if (!embeddedInCabinetPage()) {
  <div class="title-bar">
    <div class="title-section">
      <h1 class="core-title">{{ 'admin.users.title' | translate }}</h1>
      @if (displayCount() !== null) {
      <span class="count">{{ displayCount() }}</span>
      }
    </div>
    @if (initialized()) {
    <button type="button" class="add-button" (click)="onAdd()">
      + {{ 'admin.users.add' | translate }}
    </button>
    }
  </div>
  }

  @if (initialized()) {
  <div class="search-bar">
    <lib-not-input
      type="text"
      [placeholder]="'admin.users.search' | translate"
      [ngModel]="searchQuery()"
      (ngModelChange)="onSearchChange($event)"
      [hideErrorBlock]="true"
    />
  </div>
  <div class="filters-bar">
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().excludeStaff"
      (ngModelChange)="onFilterChange({ excludeStaff: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.excludeStaff' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().debtorsOnly"
      (ngModelChange)="onFilterChange({ debtorsOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.debtorsOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().verifiedOnly"
      (ngModelChange)="onFilterChange({ verifiedOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.verifiedOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().activeStorageOnly"
      (ngModelChange)="onFilterChange({ activeStorageOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.activeStorageOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().activeOrdersOnly"
      (ngModelChange)="onFilterChange({ activeOrdersOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.activeOrdersOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().blockedOnly"
      (ngModelChange)="onFilterChange({ blockedOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.blockedOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().withoutStorageOnly"
      (ngModelChange)="onFilterChange({ withoutStorageOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.withoutStorageOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().partnersOnly"
      (ngModelChange)="onFilterChange({ partnersOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.partnersOnly' | translate }}
    </lib-not-input>
    <lib-not-input
      type="checkbox"
      [ngModel]="filters().personalRateOnly"
      (ngModelChange)="onFilterChange({ personalRateOnly: $event })"
      [hideErrorBlock]="true"
    >
      {{ 'admin.users.personalRateOnly' | translate }}
    </lib-not-input>
  </div>
  }

  <div class="users-list" #usersList>
    @if (!loadError() && items().length > 0) {
    @for (row of items(); track row.user.id) {
    <a
      class="user-card"
      [class.user-card--debtor]="isDebtor(row)"
      [class.deactivated]="!row.user.is_active"
      [href]="userDetailHref(row.user.id)"
      (click)="openUser(row.user.id, $event)"
    >
      <div class="card-header">
        <div
          class="avatar"
          [class.avatar--has-photo]="!!row.user.photo_url?.trim()"
        >
          @if (row.user.photo_url?.trim(); as photoUrl) {
          <img
            class="avatar__img"
            [src]="photoUrl"
            alt=""
            loading="lazy"
            decoding="async"
          />
          } @else {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle cx="12" cy="8" r="4" stroke="white" stroke-width="2" />
            <path
              d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          }
        </div>
        <div class="user-info">
          <div class="name-row">
            <div class="name">{{ formatName(row) }}</div>
            @if (!row.user.is_active) {
            <span class="deactivated-badge">{{
              'warehouse.status.inactive' | translate
            }}</span>
            }
          </div>
          @if (row.position) {
          <div class="meta">{{ row.position }}</div>
          }
          <div class="meta">{{ row.user.phone }}</div>
          @if (isDebtor(row)) {
          <div class="meta meta--debt">{{ formatDebtorBalance(row) }}</div>
          }
          <div class="badges">
            @if (isStaffUser(row.user.roles)) {
            @for (role of row.user.roles; track role) {
            <span class="role-badge">{{
              'admin.employees.roles.' + role | translate
            }}</span>
            }
            } @else if (row.user.roles.includes('partner')) {
            <span class="role-badge">{{
              'admin.employees.roles.partner' | translate
            }}</span>
            } @else {
            <span class="role-badge role-badge--client">{{
              'admin.users.badgeClient' | translate
            }}</span>
            }
          </div>
        </div>
      </div>

      <lib-staff-client-messenger-actions
        [messengers]="clientMessengers(row)"
        [showPhone]="true"
        [phone]="row.user.phone"
        [compact]="true"
      />
    </a>
    }
    @if (loadingMore()) {
    <div class="load-more-row">
      <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    </div>
    }
    } @else if (
      !loadError() &&
      !loading() &&
      initialized() &&
      items().length === 0 &&
      searchQuery()
    ) {
    <div class="users-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.users.notFound' | translate }}</p>
        <p class="empty-hint">{{ 'admin.users.notFoundHint' | translate }}</p>
      </div>
      <span>&nbsp;</span>
    </div>
    } @else if (
      !loadError() &&
      !loading() &&
      initialized() &&
      items().length === 0
    ) {
    <div class="users-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.users.empty' | translate }}</p>
        <p class="empty-hint">{{ 'admin.users.emptyHint' | translate }}</p>
      </div>
      <span>&nbsp;</span>
    </div>
    } @else if (loadError() && !loading()) {
    <div class="users-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <p class="empty-text">{{ 'admin.users.loadError' | translate }}</p>
      </div>
      <span>&nbsp;</span>
    </div>
    } @else if (loading()) {
    <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    }
  </div>
</div>
